<script>
export default {
  name: 'NotificationSkeleton',
};
</script>
<template>
  <div>
    <div class="notification-item-skeleton-container" v-for="n in 12" :key="n">
      <b-skeleton animation="fade" width="100%"></b-skeleton>
      <b-skeleton animation="fade" width="85%"></b-skeleton>
      <div class="notification-item-skeleton-value">
        <b-skeleton animation="fade" width="35%"></b-skeleton>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.notification-item-skeleton-container {
  display: flex;
  position: relative;
  flex-direction: column;
  padding: .5rem;
  margin: 1rem .5rem;
  .notification-item-skeleton-value {
    margin-top: 16px;
    display: flex;
    flex-direction: row-reverse;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-notification/skeleton/index.vue